import React from 'react';
import { Box, Typography } from '@mui/material';
import { themeColors } from '../../styles';

interface Props {
  icon: React.ReactNode;
  message: string;
}

/**
 * Compact empty row for the home-page sections (updates / orders / service
 * calls). Kept small and understated — three of these stack on one screen, so
 * each reads as a tidy placeholder rather than a big "nothing here" block.
 */
const SectionEmpty = ({ icon, message }: Props) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      px: 2,
      py: 2,
      mt: 1.5,
      borderRadius: '14px',
      backgroundColor: themeColors.whiteBaseCards,
      border: `1px dashed ${themeColors.placeholdersInput}`,
    }}
  >
    <Box
      sx={{
        width: 44,
        height: 44,
        flexShrink: 0,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: themeColors.baseDark,
      }}
    >
      {icon}
    </Box>
    <Typography sx={{ fontSize: '14px', lineHeight: '20px', color: themeColors.paragraphInputTag }}>
      {message}
    </Typography>
  </Box>
);

export default SectionEmpty;
